import {
	Component,
	ElementRef,
	Input,
	OnChanges,
	OnDestroy,
	OnInit,
	ViewChild
} from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { FileUploadDataProvider } from '@services/files/file-upload.data.service';
import { FileUploadServiceProvider } from '@services/files/file-upload-service/file-upload.service';

@Component({
	selector: '',
	template: ''
})
export class ClientPhotoComponent implements OnInit, OnChanges, OnDestroy {
	@Input() isPhoto?: boolean;
	@Input() clientId: number;
	@Input() hasAvatar?: boolean;
	@ViewChild('inputFile') inputFile: ElementRef;
	clientImg: string;
	unsubscribe: Subject<void> = new Subject();

	constructor(
		public fileUploadDataService: FileUploadDataProvider,
		public fileUploadService: FileUploadServiceProvider
	) {}

	ngOnInit(): void {
		this.fileUploadDataService.newPhoto$
			.takeUntil(this.unsubscribe)
			.subscribe((clientId): void => {
				if (clientId !== null && typeof clientId !== 'undefined') {
					if (this.clientId === clientId) {
						this.isPhoto = true;
						this.getClientPhoto(this.clientId);
					}
				} else if (this.clientId === null && this.hasAvatar) {
					this.getUserPhoto();
				}
			});
	}

	ngOnChanges(): void {
		if (this.isPhoto && this.clientId) {
			this.getClientPhoto(this.clientId);
		} else if (this.isPhoto && this.clientId === null) {
			this.getUserPhoto();
		}
	}

	ngOnDestroy(): void {
		this.fileUploadDataService.emitNewPhoto(null);
		this.unsubscribe.next();
		this.unsubscribe.complete();
	}

	getFile(event): void {
		if (event && event.target.files) {
			const img: any = new Image();
			const file = event.target.files[0];

			if (!this.fileUploadService.isClientPhotoValid(file)) {
				this.inputFile.nativeElement.value = '';
				return;
			}

			this.readFile(img, file);
		}
	}

	readFile(img, file): void {
		const fileReader: FileReader = new FileReader();

		fileReader.onloadend = (loadEvent: any) => {
			img.src = loadEvent.target.result;
			this.fileUploadDataService.emitUploadedPhoto({
				img,
				clientId: this.clientId
			});
			this.inputFile.nativeElement.value = '';
			this.showModal();
		};

		fileReader.readAsDataURL(file);
	}

	showModal(): void {}

	getClientPhoto(clientId: number) {
		this.fileUploadDataService.getClientPhoto(clientId).subscribe(data => {
			this.clientImg = this.fileUploadService.objectToBase64String(data);
		});
	}
	getUserPhoto() {
		this.fileUploadDataService.getUserPhoto().subscribe(data => {
			this.isPhoto = true;
			this.clientImg = this.fileUploadService.objectToBase64String(data);
		});
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=kkml25e9zf!./shared/components/base/client/client-photo/client-photo.ts